import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Link from '../Link'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'

export default function CompanyContactSection({ title, subtitle, ctaText }) {
  const email = subtitle ? subtitle.subtitle.split('\n')[1] : ''
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" className={styles.gradBorder} />
        <h2>{title}</h2>
        <div className={styles.subtitle}>
          {subtitle ? subtitle.subtitle.split('\n')[0] : ''}
        </div>
        <div className={styles.emailHeader}>{ctaText}</div>
        <div className={styles.emailLink}>
          <Link to={'mailto:' + email}>{email}</Link>
        </div>
      </div>
    </div>
  )
}
